import React, { useState, useEffect } from 'react'
import '../About/About.css';
const Btnwp = () => {

  const [showWpButton, setShowWpButton] = useState(false)

useEffect(() => {
  const intervalId = setInterval(() => {
    setShowWpButton(true)
  }, 5000)
/*   return () => clearInterval(intervalId) */
},[])


  return (
    <>
      {showWpButton && <a className='btn-wp' href='https://wa.me/2235985787' target='_blank'><i className="bi bi-whatsapp bwp"></i></a> }  
      </>
  )
  
}

export default Btnwp